import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule FileFuncDocumentCheckSvgModule
 */
@Component({
  selector: 'svg[systemcodeFileFuncDocumentCheck]',
  template: '<svg:path d="M12.34 3.33v4.73h4.73" fill="none" stroke="#193864" stroke-linecap="round" stroke-linejoin="round"></svg:path><svg:path d="M17.07 10.06v-2l-4.73-4.73H2.89v17.34h7.8" fill="none" stroke="#193864" stroke-linecap="round" stroke-linejoin="round"></svg:path><svg:path d="M15.44 16.64l1.11 1.11 2.22-2.22" fill="none" stroke="#9ccb66" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.17"></svg:path><svg:circle cx="17.09" cy="16.64" r="4" stroke-width="1.17" stroke="#9ccb66" stroke-linecap="round" stroke-linejoin="round" fill="none"></svg:circle>',

  styles: [
  ],

  host: {
    'viewBox': '0 0 24 24',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileFuncDocumentCheckSvgComponent {
}

@NgModule({
  declarations: [
    FileFuncDocumentCheckSvgComponent,
  ],
  exports: [
    FileFuncDocumentCheckSvgComponent,
  ],
})
export class FileFuncDocumentCheckSvgModule {}
